import { createSlice } from "@reduxjs/toolkit"

  export const productSlice = createSlice({
    name: 'product',
    initialState:{productList:[], categoryList:[], productFilterList:[]},
    reducers: {
      setProducts:(state, action) => {
          state.productList = action.payload     
      },
      setFilterProducts:(state, action) => {
        state.productFilterList = action.payload     
       },
      setCategories:(state, action) => {
        state.categoryList = action.payload
      },
      setSelectedCategory:(state, action) => {
        state.categoryList = action.payload
      }
    },
  })
  
  export const {setProducts, setCategories, setSelectedCategory,setFilterProducts} = productSlice.actions
  
  export default productSlice.reducer